import { Agency, agencyBasic } from '@app/models';
import { DictionaryEntity } from '@app/pcs/models';
import { gql } from 'apollo-angular';

export interface Comment {
  userAgency?: string;
  userFirstName?: string;
  userLastName?: string;
  id?: number;
  pfUserId?: number;
  dossierStatus?: DictionaryEntity;
  description?: string;
  observation?: Observation;
  updateDate?: Date;
  deleted?: boolean;
  edited?: boolean;
  commentType?: DictionaryEntity;
  agencyRecipients?: Agency[];
}

export interface Observation {
  involvedImIds: number[];
  id?: number;
  noteElementId?: number;
  pathId?: number;
  firstPathSectionId?: number;
  lastPathSectionId?: number;
  observationTypes?: DictionaryEntity[];
  comment?: string;
  justified?: boolean;
  stamp?: string;
}

export enum CommentAclActionMap {
  UpdateComment = 'UpdateComment'
}

export interface ObservationSubPath {
  pathId: number;
  imId: number;
  origin: string;
  destination: string;
  title: string;
  agencyType: string;
  validationPeriod: string;
}

export const observationAgency = gql`
  fragment observationAgency on Agency {
    id
    name
  }`;

export const observationSubPath = gql`
  fragment observationSubPath on ObservationSubPath {
    pathId
    imId
    origin
    destination
    title
    agencyType
    validationPeriod
  }`;

export const comment = gql`
  fragment comment on Comment {
    userAgency
    userFirstName
    userLastName
    id
    pfUserId
    dossierStatus {
      id
      description
    }
    description
    updateDate
    deleted
    edited
    observation {
      involvedImIds
      id
      noteElementId
      pathId
      firstPathSectionId
      lastPathSectionId
      observationTypes {
        id
        description
      }
      comment
      justified
    }
    commentType {
      id
      description
    }
    agencyRecipients {
      ...agencyBasic
    }
  }
  ${agencyBasic}
`;
